export const THEME = {
  fonts: {
    sans: '"Exo 2", sans-serif',
    mono: "monospace",
    pixel: '"Press Start 2P"',
  },
  colors: {
    black: 0x000000,
    blackText: "#000000",
    nearBlack: 0x0a0a12,
    bgText: "#0c0a15",
    ink: 0x0a0a1a,
    inkText: "#0a0a1a",
    inkAlt: 0x08081a,
    inkAltText: "#08081a",
    screen: 0x05060a,
    screenAlt: 0x06070e,
    panel: 0x0f1324,
    panelAlt: 0x111122,
    panelMuted: 0x171b32,
    panelHover: 0x1f2340,
    panelOverlay: 0x020617,
    panelCard: 0x1a1a2e,
    panelCardSelected: 0x1a1a3a,
    panelCardAlt: 0x12142a,
    panelCardDark: 0x0c0d18,
    panelCardHover: 0x252548,
    panelButtonDark: 0x1a1a1a,
    panelButtonHover: 0x2a2a2a,
    panelControl: 0x222233,
    panelControlHover: 0x333355,
    panelDisabled: 0x333344,
    borderMuted: 0x2a2a4e,
    borderStrong: 0x222244,
    white: 0xffffff,
    whiteText: "#ffffff",
    whiteTextDim: "#ffffffcc",
    whiteTextSoft: "#e5e7eb",
    whiteTextBlue: "#e5f6ff",
    mutedTextBlue: "#8888aa",
    slateText: "#dbeafe",
    mutedText: "#9ca3af",
    mutedTextSoft: "#cbd5e1",
    mutedTextLighter: "#d1d5db",
    dimText: "#777777",
    disabledText: "#666666",
    disabledTextDark: "#555555",
    blackOverlayText: "#000000aa",
    cyanText: "#00f0ff",
    cyanSoft: 0x67e8f9,
    cyanSoftText: "#67e8f9",
    cyanBright: 0x22d3ee,
    cyanBrightText: "#22d3ee",
    blueSoftText: "#a5b4fc",
    purpleSoftText: "#c4b5fd",
    amberSoft: 0xfef3c7,
    amberSoftText: "#fef3c7",
    magentaText: "#ff00ff",
    shadowCyan: "#00f0ff44",
    shadowRed: "#ef444444",
    shadowGold: "#fbbf2488",
    shadowPurple: "#b24dff44",
    success: 0x22c55e,
    successBright: 0x4ade80,
    successText: "#22c55e",
    warning: 0xfbbf24,
    warningBright: 0xfcd34d,
    warningText: "#fbbf24",
    danger: 0xef4444,
    dangerBright: 0xff6666,
    dangerDeep: 0xb91c1c,
    dangerAlert: 0xdc2626,
    dangerText: "#ef4444",
    orange: 0xf97316,
    orangeSoft: 0xf59e0b,
    orangeText: "#f59e0b",
    blue: 0x3b82f6,
    blueBright: 0x4d8dff,
    indigo: 0x6366f1,
    info: 0x60a5fa,
    infoText: "#60a5fa",
    mutedBlue: 0x94a3b8,
    mutedBlueDark: 0x64748b,
    mutedBlueLight: 0xcbd5e1,
    violet: 0x8b5cf6,
    purple: 0xa855f7,
    purpleText: "#a855f7",
    magenta: 0xec4899,
    pink: 0xf472b6,
    gray: "#9ca3af",
  },
  neon: {
    cyan: 0x00f0ff,
    magenta: 0xff00ff,
    pink: 0xff2d95,
    gold: 0xfbbf24,
    green: 0x39ff14,
    blue: 0x4d8dff,
    purple: 0xb24dff,
    red: 0xff2222,
  },
  roles: {
    balanced: 0x3b82f6,
    tank: 0xef4444,
    speed: 0xeab308,
    multi: 0xec4899,
    sniper: 0x8b5cf6,
  },
  shadows: {
    cyan: "#00f0ff44",
    cyanStrong: "#00f0ff66",
    cyanSoft: "#00f0ff33",
    red: "#ef444444",
    redStrong: "#ef444488",
    pink: "#f472b666",
    yellow: "#f59e0b66",
    gold: "#fbbf2488",
    goldSoft: "#fbbf2466",
    goldFaint: "#fbbf2444",
    green: "#22c55e88",
    greenSoft: "#22c55e44",
    purple: "#b24dff44",
    white: "#ffffff33",
  },
  heroColors: {
    bella: {
      glow: 0xf472b6,
      glowText: "#f472b6",
      neon: 0xff2d95,
    },
    krmelo: {
      glow: 0xf59e0b,
      glowText: "#f59e0b",
      neon: 0xfbbf24,
    },
  },
} as const
